/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { lazy } from 'react';
import styled from 'styled-components';

import { WidgetLazyLoadWrapper } from '../common/utilities/widgetLazyLoadWrapper';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { mediumMediaQuery, smallMediaQuery } from '../../common/utilities/sizeHelpers';

const HurricaneWidget = lazy(() => import('./hurricaneWidget'));

export const HurricaneWidgetLazy = () => {
    return (
        <WidgetLazyLoadWrapper suspenseFallbackLoadingUI={<HurricaneWidgetLazyLoadingUI />}>
            <HurricaneWidget />
        </WidgetLazyLoadWrapper>
    );
};

const HurricaneWidgetLazyLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='100%' radius={3} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 283px;

    @media ${smallMediaQuery} {
        height: 133px;
    }

    @media ${mediumMediaQuery} {
        height: 158px;
    }
`;

